import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { IntegrationsPage } from '../../../components/integrations/IntegrationsPage.js';
import { SUPPORTED_PROVIDERS } from '../../../components/integrations/networks.js';

const integrationsSearchSchema = z.object({
  connected: z.literal('1').optional().catch(undefined),
  error: z.string().optional().catch(undefined),
  provider: z.enum(SUPPORTED_PROVIDERS).optional().catch(undefined),
  productId: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute('/settings/integrations/')({
  validateSearch: (search) => integrationsSearchSchema.parse(search),
  component: IntegrationsPage,
});
